export default {
	"emailInput.placeholder": "mail@example.com",
} as const;
